import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';

const Header = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      style={{ padding: '0 0.25rem' }}
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      primaryopacity={1}
      secondaryospacity={0.6}
      width="100%"
      height="40"
      preserveAspectRatio="xMinYMin"
    >
      <rect x="10" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="220" y={0} rx="5" ry="5" width="70" height="20" />
      <rect x="57%" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="67%" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="81%" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="94%" y={0} rx="5" ry="5" width="70" height="20" />
    </ContentLoader>
  );
};
const Table = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      style={{ padding: '0.5rem' }}
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      primaryopacity={1}
      secondaryospacity={0.6}
      width="100%"
      height="95%"
      preserveAspectRatio="xMinYMin"
    >
      {Array(5)
        .fill('')
        .map((e, i) => (
          <React.Fragment key={i}>
            {/* Thumb  */}
            <rect
              key={i}
              x="10"
              y={160 * i}
              rx="10"
              ry="10"
              width="200"
              height="100"
            />
            {/* Info  */}
            <rect
              x="220"
              y={160 * i}
              rx="5"
              ry="5"
              width={`${Math.random() * (18 - 12) + 12}%`}
              height="15"
            />
            <rect
              x="220"
              y={160 * i + 20}
              rx="5"
              ry="5"
              width={`${Math.random() * (12 - 7) + 7}%`}
              height="15"
            />
            <rect
              x="220"
              y={160 * i + 40}
              rx="5"
              ry="5"
              width={`${Math.random() * (12 - 7) + 7}%`}
              height="15"
            />
            <rect
              x="220"
              y={160 * i + 60}
              rx="5"
              ry="5"
              width={`${Math.random() * (18 - 12) + 12}%`}
              height="15"
            />
            {/* Flags  */}
            <rect
              x="220"
              y={160 * i + 80}
              rx="5"
              ry="5"
              width="130"
              height="25"
            />
            <rect
              x="370"
              y={160 * i + 80}
              rx="5"
              ry="5"
              width="130"
              height="25"
            />
            <rect
              x="520"
              y={160 * i + 80}
              rx="5"
              ry="5"
              width="130"
              height="25"
            />
            {/* Editor e Avaliador */}
            <circle cx="60%" cy={160 * i + 60} r="25" />
            <circle cx="70%" cy={160 * i + 60} r="25" />
            {/* Avaliação */}
            <rect
              x="80%"
              y={160 * i + 20}
              rx="5"
              ry="5"
              width="150"
              height="40"
            />
            <rect
              x="80%"
              y={160 * i + 75}
              rx="5"
              ry="5"
              width="150"
              height="40"
            />
            {/* Buttons */}
            <circle cx="98%" cy={160 * i + 20} r="20" />
            <circle cx="98%" cy={160 * i + 65} r="20" />
            <circle cx="98%" cy={160 * i + 110} r="20" />
          </React.Fragment>
        ))}
    </ContentLoader>
  );
};

const Loader = () => {
  return (
    <>
      <Header />
      <Table />
    </>
  );
};

export default Loader;
